/**
 * Shared Tailwind class strings for public-facing forms (contact, login, signup).
 *
 * These live in one place so every form on the public site focuses, errors and
 * submits in the same brand green. The dashboard is still Bootstrap and does not
 * use these — see aiAgents/docs/FRONTEND-PATTERNS.md.
 */

export const labelClass = "mb-1.5 block text-xs font-semibold text-ink-600";

export const fieldClass =
  "w-full rounded-lg border border-ink-200 bg-white px-3.5 py-2.5 text-fluid-sm text-ink-900 placeholder:text-ink-400 transition focus:border-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-600/20";

export const fieldErrorClass =
  "w-full rounded-lg border border-red-400 bg-white px-3.5 py-2.5 text-fluid-sm text-ink-900 placeholder:text-ink-400 transition focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20";

// The two above with room on the right for a show-password button. Spelled out
// rather than `${fieldClass} pr-12`: px-3.5 and pr-12 collide, and the
// stylesheet's order — not the string's — would pick the winner.
export const passwordFieldClass =
  "w-full rounded-lg border border-ink-200 bg-white py-2.5 pl-3.5 pr-12 text-fluid-sm text-ink-900 placeholder:text-ink-400 transition focus:border-brand-600 focus:outline-none focus:ring-2 focus:ring-brand-600/20";

export const passwordFieldErrorClass =
  "w-full rounded-lg border border-red-400 bg-white py-2.5 pl-3.5 pr-12 text-fluid-sm text-ink-900 placeholder:text-ink-400 transition focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500/20";

export const primaryButtonClass =
  "inline-flex w-full items-center justify-center rounded-full bg-brand-600 px-6 py-3 text-sm font-semibold text-white shadow-brand transition hover:bg-brand-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600 disabled:cursor-not-allowed disabled:opacity-60 disabled:shadow-none";

export const textLinkClass =
  "font-semibold text-brand-700 transition hover:text-brand-800 hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-600";
